import type { ButtonTokens, SemanticTokens, RadiusScale, SpacingScale } from '@/theme/types'

export const createButtonTokens = (
  semantic: SemanticTokens,
  radius: RadiusScale,
  spacing: SpacingScale,
): ButtonTokens => ({
  height: 40,
  paddingX: spacing[4],
  paddingY: spacing[2],
  borderRadius: radius.md,
  background: semantic.colors.primary,
  backgroundHover: semantic.colors.primaryHover,
})

